import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog, faExclamationCircle } from '@fortawesome/pro-light-svg-icons'

import {
  Box, IconWithMenu, Link, ListItem, Text,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import usePublicationInspection from '@hooks/usePublicationInspection'
import useSelector from '@hooks/useSelector'

import type { SecondaryGroupModel } from '@functions/publicationEdition'

import InspectionListItem from './InspectionListItem'

interface AgencyGroupProps {
  agencyGroup: SecondaryGroupModel,
  publicationEditionId: number,
}

const AgencyGroup = (props: AgencyGroupProps) => {
  const { agencyGroup, publicationEditionId } = props
  const { id: agencyId, entityIds: agencyIds } = agencyGroup

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      sendPublicationInspectionsAlert,
    },
  } = pageContext

  const {
    callbacks: {
      sendPublicationInspectionsAlert: sendAlertFn,
    },
  } = usePublicationInspection()

  const entityParams = {
    agency_id: agencyId,
    edition_id: publicationEditionId,
  }

  const sendPublicationInspectionsAlertPayload = {
    callbacks: {
      action: sendAlertFn,
    },
    entityParams,
    toastText: 'Alert Sent',
  }

  const agencies = useSelector(reduxState => reduxState.entities.agencies)
  const agency = agencies[agencyId] || {}

  const agencyInspectionCount = agencyIds.length || 0
  const tertiaryText = agencyInspectionCount === 1 ? '1 Inspection' : `${agencyInspectionCount} Inspections`

  return (
    <>
      <ListItem
        boxProps={{
          alignItems: 'center',
          borderBottom: '1px dashed',
          fontSize: 'small',
          padding: 'large',
        }}
        disableHover
      >
        <Box
          flexDirection="column"
          maxWidth="80%"
          paddingRight="large"
        >
          <Text fontWeight={600}>{agency.title}</Text>
        </Box>

        <Box justifyContent="flex-end">
          <Text color="faintGrey" marginRight="medium">
            {tertiaryText}
          </Text>

          <IconWithMenu
            icon={(
              <Link greyLink>
                <FontAwesomeIcon icon={faCog} />
              </Link>
            )}
          >
            {/*
             // @ts-expect-error TS2741 */}
            <IconWithMenu.Menu closeOnClick>
              <Link onClick={() => sendPublicationInspectionsAlert(sendPublicationInspectionsAlertPayload)}>
                <FontAwesomeIcon icon={faExclamationCircle} /> Send Alert
              </Link>
            </IconWithMenu.Menu>
          </IconWithMenu>
        </Box>
      </ListItem>

      {agencyIds.map((id: number) => (
        <InspectionListItem
          key={id}
          inspectionId={id}
        />
      ))}
    </>
  )
}

export default AgencyGroup
